import React, { useState, useEffect, useRef } from 'react';
import styles from '../../../styles/TaskDetails.module.css';

interface TaskDescriptionTextProps {
  description: string;
}

const TaskDescriptionText: React.FC<TaskDescriptionTextProps> = ({ description }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldTruncate, setShouldTruncate] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight);
      const maxHeight = lineHeight * 5; // 5 lines
      setShouldTruncate(textRef.current.scrollHeight > maxHeight);
    }
  }, [description]);

  const toggleExpanded = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent any parent click events
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={styles.taskDescriptionContainer}>
      <div 
        ref={textRef}
        className={`${styles.taskDescriptionText} ${!isExpanded && shouldTruncate ? styles.truncated : ''}`}
        style={{ whiteSpace: 'pre-wrap' }}
      >
        {description}
      </div>
      {shouldTruncate && (
        <button 
          className={styles.moreButton}
          onClick={toggleExpanded}
        >
          {isExpanded ? 'Show Less' : ' Show More'}
        </button>
      )}
    </div>
  );
};

export default TaskDescriptionText;

